module.exports = __webpack_public_path__ + "static/img/mingshiicon2.24caf595.png";